var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0659 3.10731L15.9294 3.08511L15.9133 3.0819C15.8825 3.07571 15.8557 3.07031 15.8233 3.07031H15.7702H1.42898H1.37592C1.35592 3.07031 1.33591 3.07444 1.31702 3.07833C1.30012 3.08181 1.28412 3.08511 1.2698 3.08511C1.2552 3.08749 1.24059 3.0891 1.22623 3.09069C1.19589 3.09404 1.16667 3.09727 1.14095 3.10731C0.564869 3.24051 0.132812 3.74372 0.132812 4.34312V14.5034C0.132812 15.2064 0.716468 15.7762 1.43656 15.7762H15.7702C16.4903 15.7762 17.074 15.2064 17.074 14.5034V4.34312C17.074 3.74372 16.6419 3.24051 16.0659 3.10731ZM15.3685 4.03263L9.27427 9.53826C8.89527 9.88607 8.29646 9.87867 7.91746 9.53826L1.82318 4.03263H15.3685ZM1.42911 14.8144H15.7704C15.9523 14.8144 16.0887 14.6738 16.1039 14.511V4.69853L9.95655 10.2486C9.57755 10.589 9.09244 10.7592 8.60732 10.7592C8.1222 10.7592 7.63709 10.589 7.25809 10.2486L1.11075 4.69853V14.5036C1.11075 14.6738 1.25477 14.8144 1.42911 14.8144Z",
    fill: "#291482"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.cd15cd5639b4bdb1ec1a1514a8b598ee.svg";
export { ForwardRef as ReactComponent };